/* Shared owner-edit gate for the two on-site editors (cw-slot-editor.js and
   cw-gallery-owner.js).

   It exists for three reasons:

   1. window.prompt() renders the password in clear text, on screen and in any
      screen share or screenshot. This replaces it with a real password field.
   2. The two editors used to be turned on separately — ?cwedit=1 for page media
      and an "Edit gallery" button for the gallery — each with its own password
      round. One flag now drives both, so a single button anywhere puts the
      whole site in edit mode.
   3. Edit mode needed a visible way out. The floating Exit button is rendered
      here once, for every page, rather than per-editor.

   The password itself is still verified server-side by the admin proxy, which
   is the only thing that can actually authorise a write — the flag below is a
   UI state, not a permission. */
(function () {
  var PROXY   = 'https://cyclewash-admin-proxy.vvlars.workers.dev/rest/graphql.json';
  var MODE_KEY = 'cw-edit-mode';
  var PW_KEY   = 'cw-admin-pass';

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }

  function isEditing() { return lsGet(MODE_KEY) === '1'; }
  function storedPass() { return lsGet(PW_KEY); }

  /* One round-trip against the proxy. It is the authority on the password;
     a true here means the same header will be accepted for a real write. */
  function verify(v) {
    return fetch(PROXY, {
      method: 'POST',
      headers: {'content-type': 'application/json', 'X-CW-Admin-Pass': v},
      body: JSON.stringify({query: '{ shop { name } }'})
    }).then(function (r) {
      if (r.ok) return true;
      if (r.status === 401 || r.status === 403) return false;
      throw new Error('proxy HTTP ' + r.status);
    });
  }

  var styled = false;
  function style() {
    if (styled) return;
    styled = true;
    var s = document.createElement('style');
    s.textContent =
      '.cw-gate{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;' +
      'justify-content:center;background:rgba(8,20,32,.62);backdrop-filter:blur(3px)}' +
      /* The storefront's dark theme restyles generic elements, so every colour
         here is forced. -webkit-text-fill-color too, or Safari keeps the
         inherited fill and the title renders dark-on-dark. */
      '.cw-gate__panel{background:#fff !important;color:#0E2A47 !important;' +
      '-webkit-text-fill-color:#0E2A47 !important;border-radius:14px;padding:22px 22px 18px;' +
      'width:min(94vw,380px);box-shadow:0 18px 60px rgba(0,0,0,.36);font:15px/1.5 system-ui,sans-serif}' +
      '.cw-gate__panel *{color:#0E2A47 !important;-webkit-text-fill-color:#0E2A47 !important}' +
      '.cw-gate__t{font-weight:700 !important;font-size:17px !important;margin:0 0 4px !important}' +
      '.cw-gate__s{margin:0 0 14px !important;font-size:13.5px !important;opacity:.72}' +
      '.cw-gate__in{width:100%;box-sizing:border-box;padding:10px 12px;font-size:16px;' +
      'border:1px solid #C3D0DC;border-radius:8px;background:#F7FAFC;color:#0E2A47}' +
      '.cw-gate__in:focus{outline:2px solid #1E82C8;outline-offset:1px;border-color:#1E82C8}' +
      '.cw-gate__err{color:#B3372A;font-size:13px;margin:8px 0 0;min-height:17px}' +
      '.cw-gate__row{display:flex;gap:8px;justify-content:flex-end;margin-top:14px}' +
      '.cw-gate__b{border:0;border-radius:8px;padding:9px 16px;font-size:14px;font-weight:600;cursor:pointer}' +
      '.cw-gate__b--go{background:#1E82C8 !important;color:#fff !important;' +
      '-webkit-text-fill-color:#fff !important}.cw-gate__b--go:disabled{opacity:.55;cursor:default}' +
      '.cw-gate__b--x{background:#EDF2F7 !important;color:#0E2A47 !important}' +
      '.cw-gate__err{color:#B3372A !important;-webkit-text-fill-color:#B3372A !important}' +
      '#cw-exit-edit{position:fixed;right:16px;bottom:16px;z-index:2147482000;background:#B3372A;' +
      'color:#fff;border:0;border-radius:999px;padding:11px 18px;font:600 14px/1 system-ui,sans-serif;' +
      'cursor:pointer;box-shadow:0 6px 22px rgba(0,0,0,.3)}' +
      '#cw-exit-edit:hover{background:#8F2C21}' +
      '@media(max-width:600px){#cw-exit-edit{right:10px;bottom:10px;padding:10px 14px;font-size:13px}}';
    document.head.appendChild(s);
  }

  /* Masked password dialog. Resolves the verified password, or null if the
     owner cancelled. Retries in place on a wrong password so a typo does not
     drop them back out of edit mode. */
  function ask(title) {
    style();
    return new Promise(function (resolve) {
      var wrap = document.createElement('div');
      wrap.className = 'cw-gate';
      wrap.innerHTML =
        '<div class="cw-gate__panel" role="dialog" aria-modal="true" aria-label="Admin password">' +
        '<p class="cw-gate__t">' + (title || 'Edit this website') + '</p>' +
        '<p class="cw-gate__s">Same password as the admin page.</p>' +
        '<input class="cw-gate__in" type="password" autocomplete="current-password" ' +
        'placeholder="Admin password" aria-label="Admin password">' +
        '<p class="cw-gate__err" role="alert"></p>' +
        '<div class="cw-gate__row">' +
        '<button type="button" class="cw-gate__b cw-gate__b--x">Cancel</button>' +
        '<button type="button" class="cw-gate__b cw-gate__b--go">Unlock</button>' +
        '</div></div>';
      document.body.appendChild(wrap);

      var input = wrap.querySelector('.cw-gate__in');
      var err   = wrap.querySelector('.cw-gate__err');
      var go    = wrap.querySelector('.cw-gate__b--go');
      var x     = wrap.querySelector('.cw-gate__b--x');
      setTimeout(function () { input.focus(); }, 30);

      function close(v) { wrap.remove(); resolve(v); }
      function submit() {
        var v = (input.value || '').trim();
        if (!v) { err.textContent = 'Enter the password.'; input.focus(); return; }
        go.disabled = true;
        err.textContent = 'Checking…';
        verify(v).then(function (ok) {
          if (ok) { lsSet(PW_KEY, v); close(v); return; }
          go.disabled = false;
          err.textContent = 'Wrong password — try again.';
          input.value = '';
          input.focus();
        }).catch(function (e) {
          go.disabled = false;
          err.textContent = 'Could not reach the server (' + e.message + ').';
        });
      }
      go.addEventListener('click', submit);
      x.addEventListener('click', function () { close(null); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit(); }
        if (e.key === 'Escape') { e.preventDefault(); close(null); }
      });
    });
  }

  /* The password both editors send with every write. Re-checks a stored one so
     a rotated password fails here rather than mid-save. */
  function getPass(title) {
    /* Signed in as an admin-tagged customer? The gated markup already carries
       the credential, so there is nothing to type. Anonymous visitors never
       receive it and still get the dialog. */
    if (window.CW_ADMIN_PASS) {
      lsSet(PW_KEY, window.CW_ADMIN_PASS);
      return Promise.resolve(window.CW_ADMIN_PASS);
    }
    var stored = storedPass();
    if (!stored) return ask(title);
    return verify(stored).then(function (ok) {
      if (ok) return stored;
      lsDel(PW_KEY);
      return ask(title);
    }).catch(function () { return stored; });   /* offline: let the write report it */
  }

  /* Turn edit mode on for the whole site. Resolves false if the owner cancels,
     so callers can leave the page as it was. */
  function enter(title) {
    return getPass(title).then(function (pw) {
      if (!pw) return false;
      lsSet(MODE_KEY, '1');
      return true;
    });
  }

  function exit() {
    lsDel(MODE_KEY);
    /* The gallery editor keeps its own sticky per-tab unlock (cw-gal-edit-on in
       sessionStorage) so a click-through back to /pages/gallery keeps the tools
       up. Clearing the site flag alone therefore left the gallery still in edit
       mode after Exit. Drop its keys too, or Exit only half exits. */
    try {
      sessionStorage.removeItem('cw-gal-edit-on');
      sessionStorage.removeItem('cw-gal-save-pw');
    } catch (e) {}
    /* Drop ?cwedit=1 too, or a reload walks straight back into edit mode. */
    try {
      var u = new URL(location.href);
      u.searchParams.delete('cwedit');
      u.hash = u.hash.replace(/#?cwedit=?1?/, '');
      location.replace(u.toString());
    } catch (e) { location.reload(); }
  }

  /* One Exit button per page, owned here so neither editor has to draw it. */
  function mountExit() {
    if (!isEditing() || document.getElementById('cw-exit-edit')) return;
    style();
    var b = document.createElement('button');
    b.id = 'cw-exit-edit';
    b.type = 'button';
    b.textContent = '✕ Exit edit mode';
    b.addEventListener('click', exit);
    document.body.appendChild(b);
  }

  window.cwAdminGate = {
    isEditing: isEditing,
    getPass: getPass,
    ask: ask,
    verify: verify,
    enter: enter,
    exit: exit,
    mountExit: mountExit
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountExit);
  } else {
    mountExit();
  }
})();
